import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Component to display dimensions information for a listing.
 * Shows dimensions in the primary unit with conversions.
 */
const SectionDimensionsMaybe = props => {
  const { publicData } = props;

  if (!publicData) {
    return null;
  }

  const { width, height, dimensionUnit } = publicData;
  const hasDimensions = width && height && dimensionUnit;

  if (!hasDimensions) {
    return null;
  }

  // Format dimensions with both units
  const formatDimensions = () => {
    const widthNum = parseFloat(width);
    const heightNum = parseFloat(height);

    // Convert to the other unit
    const convertedWidth = dimensionUnit === 'inches'
      ? (widthNum * 2.54).toFixed(1)
      : (widthNum / 2.54).toFixed(1);
    const convertedHeight = dimensionUnit === 'inches'
      ? (heightNum * 2.54).toFixed(1)
      : (heightNum / 2.54).toFixed(1);

    // Get unit symbols
    const primarySymbol = dimensionUnit === 'inches' ? '"' : 'cm';
    const secondarySymbol = dimensionUnit === 'inches' ? 'cm' : '"';

    return `${widthNum}x${heightNum}${primarySymbol}-${convertedWidth}/${convertedHeight}${secondarySymbol}`;
  };

  const dimensionsDisplay = formatDimensions();

  return (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.dimensionsTitle" />
      </Heading>
      <p className={css.dimensionsValue}>{dimensionsDisplay}</p>
    </section>
  );
};

export default SectionDimensionsMaybe;
